import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "container-fluid p-0" }
const _hoisted_3 = { class: "comingsoon" }
const _hoisted_4 = { class: "comingsoon-inner text-center" }
const _hoisted_5 = { class: "logo-wrraper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "countdown",
  id: "clockdiv"
}

import { getImages } from "@/composables/commen/getImages"
import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'comingsoonPage',
  setup(__props) {

const comingsoonTimer = defineAsyncComponent(() => import("@/components/commen/comingsoonTimer.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: _unref(getImages)('logo/logo-1.png'),
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("h5", null, "WE ARE COMING SOON", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(comingsoonTimer))
          ])
        ])
      ])
    ])
  ]))
}
}

})